<template>
    <ies-form-field :field="field">
        <v-text-field hide-details
            :name="this.field.fieldName"
            v-model="input" v-on:keyup="updateField()"
            :required="this.field.required"
            :disabled="this.field.disabled"
            outlined
            dense
        ></v-text-field>
    </ies-form-field>
</template>

<script>
export default {
    name: 'ies-text',
    props: ['field'],
    components: {
        'ies-form-field': require('./FormField.vue').default,
    },
    data () {
        return {
            input: this.field.value || this.field.oldValue,
        }
    },
    methods: {
        updateField: function(){
            this.field.value = this.input;
            this.$root.$emit('Edit: Update Field', {'id': 'notset', 'field': this.field, 'value': this.field.value});
        },
    },
/*
    computed:{
        'errorMessages': {
            get:function(){
                console.log("computed error messages ", this.field.errors);
                return this.field.errors;
            }
        } 
    }
*/
}
</script>
